// NOTE: DateRangePicker документация на сайте не актуальна, смотреть исходный код.
class GoodOkDataRangePicker {
  constructor(type, with_interval) {
    if (with_interval) {
      this.set_init_interval(with_interval);
      if (!this.interval) this.interval = with_interval;
    }
    this.interval_key = type + '-goodok_date_interval';
    this.get_current_date_interval();
  };

  saveToLocalStorage(interval) {
    localStorage.setItem(
        this.interval_key,
        JSON.stringify(interval)
    );
  };

  get dates() {
    return [this.interval.start.format('DD.MM.YYYY'), this.interval.end.format('DD.MM.YYYY')];
  };
  
  init() {
    let picker_element = document.querySelector('#daterangepicker');
    if ( !picker_element ) { return false; }
    if ( !this.daterangepicker ){
      this.daterangepicker = new DateRangePicker(
          $(picker_element),
          this.daterangepicker_config(),
          this.set_current_date_interval
      )
    }
    daterangepicker_init_callback();
    this.change_text(this.interval.start, this.interval.end);
  };

  get_current_date_interval() {
    if (this.interval) return;
    let ls_value = localStorage.getItem(this.interval_key);
    if (ls_value) {   
      let parsed_value = JSON.parse(ls_value);
      this.set_init_interval(parsed_value);
      if (!this.interval) localStorage.removeItem(this.interval_key);
    }
    if (!this.interval){
      this.interval = {
        start: this.now_date().subtract(1, 'month'),
        end: this.now_date()
      };
    }
  };

  set_init_interval(parsed_value){
    this.set_ranges();
    let range = parsed_value['range-key'] && this.ranges[parsed_value['range-key']];
    if (range && parsed_value['range-key'].indexOf('Прошлый') === -1 && parsed_value['range-key'] !== 'Вчера'){
      //отображаем только те которые показывают текущие данные
      this.interval = { start: range[0], end: range[1] }
    }
  }

  set_current_date_interval(start, end, label) {
    if (!goodok_daterangepicker.is_date_changed(start, end)) { return; }
    goodok_daterangepicker.interval = {
      start: start,
      end: end,
      'range-key': label
    };
    goodok_daterangepicker.saveToLocalStorage(goodok_daterangepicker.interval);
    goodok_daterangepicker.change_text(start, end);
    if (typeof daterangepicker_change_callback == 'function') {
      daterangepicker_change_callback();
    }
  };

  is_date_changed(start, end) {
    let current_interval = JSON.stringify([this.interval.start, this.interval.end]);
    let new_interval = JSON.stringify([start, end]);
    return current_interval != new_interval;
  };

  change_text(start, end) {
    let output_string = `${start.format('DD.MM.YY')} – ${end.format('DD.MM.YY')}`;
    $('#daterangepicker-text').html(output_string);
  };

  set_ranges(){
    if (this.ranges) return this.ranges;
    let now = this.now_date();
    this.ranges = {
       'Сегодня': [now.clone(), now.clone()],
       'Вчера': [now.clone().subtract(1, 'days'), now.clone().subtract(1, 'days')],
       'Этот месяц': [now.clone().startOf('month'), now.clone().endOf('month')],
       'Прошлый месяц': [now.clone().subtract(1, 'month').startOf('month'), now.clone().subtract(1, 'month').endOf('month')],
       'Этот квартал': [now.clone().startOf('Q'), now],
       'Прошлый квартал': [now.clone().subtract(1, 'Q').startOf('Q'), now.clone().subtract(1, 'Q').endOf('Q')],
       'Этот год': [now.clone().month(0).startOf('month'), moment().clone().month(11)],
       'Прошлый год': [now.clone().subtract(1, 'year').month(0).startOf('month'), now.clone().subtract(1, 'year').month(11).endOf('month')],
    }
    return this.ranges;
  }

  now_date(){
    return moment($('meta[name=current_user]').attr('data-date') || new Date());
  }

  daterangepicker_config() {
    return {
      startDate: this.interval.start,
      endDate: this.interval.end,
      opens: 'center',
      maxDate: this.now_date().endOf('day').format('DD.MM.YYYY'),
      locale: {
        format: 'DD.MM.YYYY',
        separator: ' – ',
        applyLabel: 'Применить',
        cancelLabel:  '<span class="custom-arrow">' +
                        '<span class="custom-arrow-wrapper">' +
                          '<span class="custom-arrow-path custom-arrow-path-top"></span>' +
                          '<span class="custom-arrow-path custom-arrow-path-bottom"></span>' +
                        '</span>' +
                      '</span>' +
                      '<span class="common-text">Отмена</span>',
        customRangeLabel: 'Другой период »'
      },
      ranges: this.set_ranges()
    };
  };
}

export default GoodOkDataRangePicker;